"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;

var styled_components_1 = __importDefault(require("styled-components"));

var Search_1 = __importDefault(require("@carvana/showroom-forms/Input/Search"));

exports.SearchInput = styled_components_1.default(Search_1.default)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), function (props) {
  return props.isExpanded && "\n    input {\n      border-bottom-right-radius: 0;\n      border-bottom-left-radius: 0;\n    }\n  ";
});
var templateObject_1;